<template>
  <div class="w-full flex items-center mt-4">
    <div class="h-[1px] w-full bg-platform-border-1" />
    <span class="px-4 text-platform-text-3 uppercase text-sm">
      {{ $t("common.or") }}
    </span>
    <div class="h-[1px] w-full bg-platform-border-1" />
  </div>
</template>
